<ngx-ui-loader text="please wait.." logoUrl="assets/images/logoanbu.png"  fgsColor="#00302b" pbColor="#00302b" logoSize="150"></ngx-ui-loader>
<router-outlet></router-outlet>